import Cookies from "js-cookie";
import type { CreateClientConfig } from "./api/client.gen";

const bearerToken = () => Cookies.get("auth_token");

const withBearer = (headers: Headers) => {
  const token = bearerToken();
  if (token && !headers.has("Authorization")) {
    headers.set("Authorization", `Bearer ${token}`);
  }
  return headers;
};

export const createClientConfig: CreateClientConfig = (config = {}) => {
  const baseFetch = config.fetch ?? globalThis.fetch.bind(globalThis);

  return {
    ...config,
    baseUrl: config.baseUrl ?? "/",
    headers: {
      "Content-Type": "application/json",
    },
    auth: bearerToken,
    // ponytail: hey-api auth() only applies when an operation has security.
    // Ceiling: custom fetch wrapper. Upgrade: generated SDK for every endpoint.
    fetch: (input, init) => {
      if (input instanceof Request) {
        return baseFetch(new Request(input, { headers: withBearer(new Headers(input.headers)) }));
      }
      return baseFetch(input, { ...init, headers: withBearer(new Headers(init?.headers)) });
    },
  };
};
